/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Insight_Ask_Consistency_StreakInputs */

const en_us2_insight_ask_consistency_streak = /** @type {(inputs: Insight_Ask_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I have trained ${i?.weeks} weeks in a row. What should I adjust to keep progressing?`)
};

const pt_br2_insight_ask_consistency_streak = /** @type {(inputs: Insight_Ask_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treinei ${i?.weeks} semanas seguidas. O que devo ajustar para continuar evoluindo?`)
};

const es_419_insight_ask_consistency_streak = /** @type {(inputs: Insight_Ask_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Llevo ${i?.weeks} semanas seguidas entrenando. ¿Qué debo ajustar para seguir progresando?`)
};

const pt_pt2_insight_ask_consistency_streak = /** @type {(inputs: Insight_Ask_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treinei ${i?.weeks} semanas seguidas. O que devo ajustar para continuar a evoluir?`)
};

const fr_fr2_insight_ask_consistency_streak = /** @type {(inputs: Insight_Ask_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je m'entraîne depuis ${i?.weeks} semaines d'affilée. Que dois-je ajuster pour continuer à progresser ?`)
};

const de_de2_insight_ask_consistency_streak = /** @type {(inputs: Insight_Ask_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich habe ${i?.weeks} Wochen am Stück trainiert. Was sollte ich anpassen, um weiter Fortschritte zu machen?`)
};

const it_it2_insight_ask_consistency_streak = /** @type {(inputs: Insight_Ask_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mi alleno da ${i?.weeks} settimane di fila. Cosa dovrei modificare per continuare a progredire?`)
};

/**
* | output |
* | --- |
* | "I have trained {weeks} weeks in a row. What should I adjust to keep progressing?" |
*
* @param {Insight_Ask_Consistency_StreakInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const insight_ask_consistency_streak = /** @type {((inputs: Insight_Ask_Consistency_StreakInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insight_Ask_Consistency_StreakInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_insight_ask_consistency_streak(inputs)
	if (locale === "es-419") return es_419_insight_ask_consistency_streak(inputs)
	if (locale === "pt-PT") return pt_pt2_insight_ask_consistency_streak(inputs)
	if (locale === "fr-FR") return fr_fr2_insight_ask_consistency_streak(inputs)
	if (locale === "de-DE") return de_de2_insight_ask_consistency_streak(inputs)
	if (locale === "it-IT") return it_it2_insight_ask_consistency_streak(inputs)
	return en_us2_insight_ask_consistency_streak(inputs)
});
export { insight_ask_consistency_streak as "insight.ask_consistency_streak" }